import { jsxs as m, jsx as o, Fragment as j } from "react/jsx-runtime";
import { withManagedProps as b } from "@made-people/managed-props";
import { z as s } from "zod";
import { withZod as C } from "@made-people/react-prop-guard";
import { voucherInputBlueprint as v, voucherListBlueprint as P, cartTotalsStyling as D, cartItemsStyling as I, cartSummaryBirchStyling as A } from "./index-blueprint.es.js";
import { AnimatePresence as V, motion as f } from "motion/react";
import { useCartMethod as x, useCartState as g, lineItemSchema as F } from "@made-people/grease-cart";
import { useTranslate as S } from "@made-people/grease-translations";
import { inputFieldSchema as L, InputField as R } from "@made-people/blueprint-form";
import { buttonAsButtonSchema as z, Button as W } from "@made-people/blueprint-button";
import { useState as T } from "react";
import { toast as N } from "@made-people/blueprint-toast";
import { linkAsButtonSchema as q, LinkAsButton as H } from "@made-people/blueprint-link";
import { CartItem as M } from "@made-people/blueprint-cart-item";
import { headingSchema as G, Heading as O } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
const B = s.object({
  inputField: L.optional(),
  applyButton: z.optional(),
  triggerLink: q.optional(),
  enabled: s.boolean().optional()
}), Q = b(
  "VoucherInput",
  C(
    {
      schema: B,
      defaultProps: {
        enabled: !0,
        inputField: {
          template: "simple",
          variants: {
            size: "sm"
          }
        }
      }
    },
    ({ inputField: a, applyButton: r, triggerLink: i, enabled: l }) => {
      const { execute: e, loadingState: t } = x("addVoucher");
      if (!l)
        return !0;
      const n = S(), [p, c] = T(!1), [_, y] = T(""), d = v.styles(), u = async () => {
        try {
          await e({ voucherCode: _ }), y(""), N({
            type: "success",
            title: n("Checkout_Voucher_Added_Success")
          }), c(!1);
        } catch {
          N({
            type: "error",
            title: n("Checkout_Voucher_Added_Error")
          });
        }
      };
      return /* @__PURE__ */ m(
        "div",
        {
          className: d.base,
          "data-is-active": p ? "true" : "false",
          children: [
            /* @__PURE__ */ o(
              H,
              {
                className: d.trigger,
                onClick: () => c(!p),
                label: n("Checkout_Voucher_Button_Text"),
                ...i
              }
            ),
            /* @__PURE__ */ o(V, { children: p && /* @__PURE__ */ m(
              f.form,
              {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                exit: { opacity: 0 },
                className: d.inputWrapper,
                onSubmit: (h) => {
                  h.preventDefault(), u();
                },
                children: [
                  /* @__PURE__ */ o(
                    R,
                    {
                      onChange: (h) => y(h.target.value),
                      value: _,
                      ...a
                    }
                  ),
                  /* @__PURE__ */ o(
                    W,
                    {
                      as: "button",
                      progress: t,
                      label: n("Checkout_Voucher_Apply"),
                      ...r
                    }
                  )
                ]
              }
            ) })
          ]
        }
      );
    }
  )
), Y = ({
  voucher: a,
  slots: r,
  isRemoveable: i
}) => {
  const { execute: l, loadingState: e } = x("removeVoucher"), t = S(), n = async () => {
    if (!a.code)
      return null;
    try {
      await l({ voucherCode: a.code }), N({
        type: "success",
        title: t("Checkout_Voucher_Remove_Success")
      });
    } catch (p) {
      N({
        type: "error",
        title: t("Checkout_Voucher_Remove_Error")
      }), console.error(p);
    }
  };
  return /* @__PURE__ */ m("div", { className: r.item, "data-state": e, children: [
    /* @__PURE__ */ o("span", { className: r.name, children: a.displayName || a.code || a.name && t("Checkout_Discount_Code", {
      code: /* @__PURE__ */ o("span", { className: r.code, children: a.name || a.code })
    }) }),
    i && a.code && /* @__PURE__ */ o("button", { className: r.deleteButton, onClick: n, children: t("Checkout_Discount_Delete", { code: a == null ? void 0 : a.code }) }),
    (a == null ? void 0 : a.discount) && (a == null ? void 0 : a.discount.number) !== 0 && /* @__PURE__ */ o("span", { className: r.discount, children: a.discount.formatted })
  ] });
}, Z = b("VoucherList", () => {
  var i, l;
  const a = g(), r = P.styles();
  return (l = (i = a.cart) == null ? void 0 : i.vouchers) != null && l.length ? /* @__PURE__ */ o("div", { className: r.base, children: a.cart.vouchers.map((e, t) => /* @__PURE__ */ o(
    Y,
    {
      slots: r,
      voucher: e,
      isRemoveable: e.type === "code" && e.isRemovable !== !1
    },
    t
  )) }) : null;
}), J = s.object({
  label: s.string().optional(),
  value: s.union([s.string(), s.custom()]).optional()
}), w = s.object({
  variants: s.custom().optional(),
  hide: s.boolean().optional(),
  customRows: s.array(J).optional(),
  voucher: B.optional(),
  fieldsEnabled: s.object({
    subtotal: s.boolean().optional(),
    discount: s.boolean().optional(),
    tax: s.boolean().optional(),
    shipping: s.boolean().optional(),
    grandTotal: s.boolean().optional()
  }).optional()
}), K = C(
  {
    schema: w,
    defaultProps: {
      hide: !1,
      voucher: {
        enabled: !0
      },
      fieldsEnabled: {
        subtotal: !0,
        discount: !0,
        tax: !0,
        shipping: !0,
        grandTotal: !0
      }
    }
  },
  ({ variants: a, customRows: r, hide: i, voucher: l, fieldsEnabled: e }) => {
    var y, d;
    const t = D.styles(a), n = S(), { cart: p } = g();
    if (!(p != null && p.totals) || (i ?? !1))
      return null;
    const c = p.totals, _ = (u) => typeof u == "function" ? u(c) : n(u);
    return /* @__PURE__ */ m(j, { children: [
      (l == null ? void 0 : l.enabled) && /* @__PURE__ */ o(Q, { ...l }),
      /* @__PURE__ */ m(f.div, { className: t.wrapper, children: [
        r == null ? void 0 : r.map((u, h) => /* @__PURE__ */ m("div", { className: t.row, children: [
          u.label && /* @__PURE__ */ o("span", { className: t.label, children: n(u.label) }),
          u.value && /* @__PURE__ */ o("span", { className: t.value, children: _(u.value) })
        ] }, h)),
        ((y = c.subtotal) == null ? void 0 : y.formatted) && (e == null ? void 0 : e.subtotal) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ o("span", { className: t.label, children: n("Checkout_CartTotals_Subtotal") }),
          /* @__PURE__ */ o("span", { className: t.value, children: c.subtotal.formatted })
        ] }),
        (l == null ? void 0 : l.enabled) && /* @__PURE__ */ o(Z, {}),
        c.discount && (e == null ? void 0 : e.discount) && /* @__PURE__ */ m("div", { className: t.row, "data-is-discounted": "true", children: [
          /* @__PURE__ */ o("span", { className: t.label, children: n("Checkout_CartTotals_Discount") }),
          /* @__PURE__ */ o("span", { className: t.value, children: c.discount.formatted })
        ] }),
        ((d = c.tax) == null ? void 0 : d.formatted) && c.tax.number !== 0 && (e == null ? void 0 : e.tax) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ o("span", { className: t.label, children: n("Checkout_CartTotals_Tax") }),
          /* @__PURE__ */ o("span", { className: t.value, children: c.tax.formatted })
        ] }),
        c.shipping && (e == null ? void 0 : e.shipping) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ o("span", { className: t.label, children: n("Checkout_CartTotals_Shipping") }),
          /* @__PURE__ */ o("span", { className: t.value, children: c.shipping.number === 0 ? n("Checkout_CartTotals_FreeShipping") : c.shipping.formatted })
        ] }),
        c.grandTotal && (e == null ? void 0 : e.grandTotal) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ o("span", { className: t.label, children: n("Checkout_CartTotals_Grandtotal") }),
          /* @__PURE__ */ o("span", { className: t.value, children: c.grandTotal.formatted })
        ] })
      ] }, "cart-totals")
    ] });
  }
), U = s.object({
  variants: s.custom().optional(),
  /**
   * Settings for the cart items, if you want to override the default settings.
   */
  itemSettings: s.custom().optional(),
  items: s.array(F).optional()
}), X = ({
  variants: a,
  itemSettings: r,
  items: i
}) => {
  const l = I.styles(a), { cart: e } = g(), t = i ?? (e == null ? void 0 : e.items);
  return /* @__PURE__ */ o(f.section, { layout: !0, id: "cart-items", className: l.wrapper, children: /* @__PURE__ */ o(V, { mode: "popLayout", initial: !1, children: t == null ? void 0 : t.map((n) => /* @__PURE__ */ o(M, { data: n, ...r }, n.lineId)) }) });
}, k = s.object({
  template: s.literal("birch"),
  variants: s.custom().optional(),
  cartTotalsSettings: w.optional(),
  headingSettings: G.optional(),
  cartDisplay: s.enum(["total_items", "total_quantity"]).optional(),
  cartItemsSettings: U.optional()
}), $ = C(
  k,
  ({
    variants: a,
    cartTotalsSettings: r,
    headingSettings: i,
    cartDisplay: l,
    cartItemsSettings: e
  }) => {
    var d;
    const t = A.styles(a), { cart: n } = g(), p = S(), c = ((d = e == null ? void 0 : e.items) == null ? void 0 : d.length) ?? (l === "total_items" ? n == null ? void 0 : n.items.length : n == null ? void 0 : n.items.reduce((u, h) => u + h.quantity, 0)), _ = (i == null ? void 0 : i.variants) ?? {
      headingSize: "xs"
    }, y = e ?? {
      itemSettings: {
        templateProps: {
          template: "tokyo"
        }
      }
    };
    return /* @__PURE__ */ m("div", { className: t.wrapper, children: [
      /* @__PURE__ */ m("div", { className: t.cartWrapper, children: [
        /* @__PURE__ */ o(
          O,
          {
            className: t.header,
            heading: p("Checkout_Your_Cart", {
              amountOfItems: c ?? 0
            }),
            ...i,
            variants: _
          }
        ),
        /* @__PURE__ */ o(X, { ...y })
      ] }),
      /* @__PURE__ */ o(
        K,
        {
          variants: {
            withBackground: "true"
          },
          ...r
        }
      )
    ] });
  }
), E = k, tt = C(
  k,
  (a) => {
    switch (a.template) {
      case "birch":
        return /* @__PURE__ */ o($, { ...a });
      default:
        return null;
    }
  }
), at = "birch", et = s.object({
  templateProps: E.optional()
}), gt = b(
  "CartSummary",
  C(et, (a) => {
    const r = a.templateProps || { template: at };
    return /* @__PURE__ */ o(tt, { ...r });
  })
);
export {
  X as CartItems,
  gt as CartSummary,
  K as CartTotals,
  tt as SelectTemplate,
  $ as TemplateBirch,
  Q as VoucherInput,
  Z as VoucherList,
  Y as VoucherRow,
  U as cartItemsSchema,
  et as cartSummaryPropsSchema,
  E as cartSummarySchema,
  k as cartSummaryTemplateBirchSchema,
  w as cartTotalsSchema,
  B as voucherInputSchema
};
//# sourceMappingURL=index.es.js.map
